export default {
    en: {
        shopOnline: '/en/shop-online',
        catalogNew: '/en/new-catalog',
        exchangeEvaluation: '/en/form/.*/*4',
        listingNew: '/en/new-inventory',
        priceQuote: '/en/form/.*/*1',
        financingRequest: '/en/form/.*/*2',
        roadTest: '/en/form/.*/*3',
        newStartFinancing: '/en/form/.*/*11',
        priceQuoteShortForm: '/en/form/.*/*22',
        advisorAppointment: '/en/form/.*/*24',
        preOrderYourCar: '/en/form/.*/*28',
        priceQuoteSimplified: '/en/form/.*/*48',
        priceQuotePowerhouse: '/en/form/.*/*50',
        financingRequestPowerhouse: '/en/form/.*/*51',
        roadTestPowerhouse: '/en/form/.*/*52',
        roadTestAtHome: '/en/form/.*/*59',
        informationRequest: '/en/form/.*/*64',
        exchangeEvaluationPowerhouse: '/en/form/.*/*68',
        rebateCoupon: '/en/form/.*/*70',
        priceRequest: '/en/form/.*/*72',
        roadTestNewInventory: '/en/form/.*/*73',
        exchangeCarEvaluation: '/en/form/.*/*81',
        financingRequestNewInventory: '/en/form/.*/*82',
        advisorAppointmentNewInventory: '/en/form/.*/*83',
        informationRequestNewInventory: '/en/form/.*/*88',
        specialOffer: '/en/form/.*/*92',
        alertMe: '/en/form/.*/*98',
        newCarAvailability: '/en/form/.*/*101',
    },
    fr: {
        shopOnline: '/fr/magasiner-en-ligne',
        catalogNew: '/fr/catalogue-neuf',
        exchangeEvaluation: '/fr/formulaire/.*/*4',
        listingNew: '/fr/inventaire-neuf',
        priceQuote: '/fr/formulaire/.*/*1',
        financingRequest: '/fr/formulaire/.*/*2',
        roadTest: '/fr/formulaire/.*/*3',
        newStartFinancing: '/fr/formulaire/.*/*11',
        priceQuoteShortForm: '/fr/formulaire/.*/*22',
        advisorAppointment: '/fr/formulaire/.*/*24',
        preOrderYourCar: '/fr/formulaire/.*/*28',
        priceQuoteSimplified: '/fr/formulaire/.*/*48',
        priceQuotePowerhouse: '/fr/formulaire/.*/*50',
        financingRequestPowerhouse: '/fr/formulaire/.*/*51',
        roadTestPowerhouse: '/fr/formulaire/.*/*52',
        roadTestAtHome: '/fr/formulaire/.*/*59',
        informationRequest: '/fr/formulaire/.*/*64',
        exchangeEvaluationPowerhouse: '/fr/formulaire/.*/*68',
        rebateCoupon: '/fr/formulaire/.*/*70',
        priceRequest: '/fr/formulaire/.*/*72',
        roadTestNewInventory: '/fr/formulaire/.*/*73',
        exchangeCarEvaluation: '/fr/formulaire/.*/*81',
        financingRequestNewInventory: '/fr/formulaire/.*/*82',
        advisorAppointmentNewInventory: '/fr/formulaire/.*/*83',
        informationRequestNewInventory: '/fr/formulaire/.*/*88',
        specialOffer: '/fr/formulaire/.*/*92',
        alertMe: '/fr/formulaire/.*/*98',
        newCarAvailability: '/fr/formulaire/.*/*101',
    },
};
